module.exports = __webpack_public_path__ + "static/webstorm5-c530b3589d2c09e2ef95b8bc2ed33ecb.png";